@use "../../styles/breakpoint.module.scss" as *;

.root {
    --items-per-row: 4;
    --gutters: calc(var(--items-per-row) - 1);
    --gutter-width: var(--grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--items-per-row));

    display: flex;
    gap: var(--gutter-width);
    justify-content: center;
    flex-wrap: wrap;

    @media ($below-mobile) {
        --items-per-row: 2;
    }
}

.item {
    width: var(--width);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-12);
    flex-shrink: 0;
    text-align: center;

    :is(.picture, :global(.imageDataWrapper)) {
        display: block;
        position: relative;
        width: 120px;
        height: 120px;

        @media ($below-mobile) {
            width: 80px;
            height: 80px;
        }

        + * {
            padding-top: var(--spacer-4);
        }
    }
}

.itemOverrideColor {
    composes: item;
}

.image,
.item svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.itemOverrideColor svg,
.itemOverrideColor svg path {
    color: var(--color-contrast);
    fill: currentColor;
}

.heading {
    font: var(--font-h-24);
}

.body {
    :is(p, li) {
        font: var(--font-p-16);
    }
}
